import { FIREBASE_CONFIG } from "../firebaseConfig";
import { APP_CONFIG } from "../appConfig";
import { SEED } from "../constants/seed";

export const DB = FIREBASE_CONFIG.databaseURL;
export const DEMO_MODE = DB.includes("YOUR_PROJECT");

export async function fbGet(path) {
  if (DEMO_MODE) return null;
  try { const r = await fetch(`${DB}/spellwise/${path}.json`); return r.ok ? await r.json() : null; }
  catch { return null; }
}
export async function fbSet(path, data) {
  if (DEMO_MODE) return;
  try { await fetch(`${DB}/spellwise/${path}.json`, { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) }); }
  catch {}
}

export const SETTINGS_LOCAL_KEY = "spellwise_settings_v1";

export function loadSettingsLocal() {
  try { const s = localStorage.getItem(SETTINGS_LOCAL_KEY); return s ? JSON.parse(s) : null; } catch { return null; }
}
export function saveSettingsLocal(s) {
  try { localStorage.setItem(SETTINGS_LOCAL_KEY, JSON.stringify(s)); } catch {}
}
export function mergeSettings(base, override) {
  if (!override) return base;
  return {
    ...base,
    ...override,
    childEmails: { ...(base.childEmails || {}), ...(override.childEmails || {}) },
    resend: { ...base.resend, ...(override.resend || {}) },
  };
}
export function getInitialSettings() {
  const cached = loadSettingsLocal();
  return mergeSettings(APP_CONFIG, cached);
}

export function loadLocal() {
  try { const s = localStorage.getItem("spellwise_v3"); return s ? JSON.parse(s) : SEED; } catch { return SEED; }
}
export function saveLocal(d) {
  try { localStorage.setItem("spellwise_v3", JSON.stringify(d)); } catch {}
}

export async function getUserLayoutPreference(userId) {
  if (DEMO_MODE) {
    try { return localStorage.getItem(`layoutPref_${userId}`) || "modern"; } catch { return "modern"; }
  }
  try {
    const r = await fetch(`${DB}/spellwise/users/${userId}/layoutPreference.json`);
    const val = r.ok ? await r.json() : null;
    return val || "modern";
  } catch { return "modern"; }
}

export async function setUserLayoutPreference(userId, layout) {
  if (DEMO_MODE) {
    try { localStorage.setItem(`layoutPref_${userId}`, layout); } catch {}
    return;
  }
  try {
    await fetch(`${DB}/spellwise/users/${userId}/layoutPreference.json`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(layout),
    });
  } catch {}
}

const DEFAULT_CATEGORIES = [
  { id: "screen-time",  name: "Screen Time",  emoji: "📱" },
  { id: "food",         name: "Food",         emoji: "🍕" },
  { id: "activities",   name: "Activities",   emoji: "🎯" },
  { id: "experiences",  name: "Experiences",  emoji: "✈️" },
];

export async function getCategories() {
  if (DEMO_MODE) {
    try {
      const raw = localStorage.getItem("spellwise_categories");
      if (raw) return JSON.parse(raw);
    } catch {}
    localStorage.setItem("spellwise_categories", JSON.stringify(DEFAULT_CATEGORIES));
    return DEFAULT_CATEGORIES;
  }
  try {
    const r = await fetch(`${DB}/spellwise/categories.json`);
    const val = r.ok ? await r.json() : null;
    if (val && typeof val === "object" && Object.keys(val).length > 0) {
      return Object.values(val);
    }
    // Seed defaults
    for (const cat of DEFAULT_CATEGORIES) {
      await fetch(`${DB}/spellwise/categories/${cat.id}.json`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(cat),
      });
    }
    return DEFAULT_CATEGORIES;
  } catch { return DEFAULT_CATEGORIES; }
}

export async function addCategory(category) {
  if (DEMO_MODE) {
    try {
      const raw = localStorage.getItem("spellwise_categories");
      const cats = raw ? JSON.parse(raw) : [...DEFAULT_CATEGORIES];
      cats.push(category);
      localStorage.setItem("spellwise_categories", JSON.stringify(cats));
    } catch {}
    return;
  }
  try {
    await fetch(`${DB}/spellwise/categories/${category.id}.json`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(category),
    });
  } catch {}
}

export async function updateCategory(id, updates) {
  if (DEMO_MODE) {
    try {
      const raw = localStorage.getItem("spellwise_categories");
      const cats = raw ? JSON.parse(raw) : [...DEFAULT_CATEGORIES];
      const idx = cats.findIndex(c => c.id === id);
      if (idx !== -1) cats[idx] = { ...cats[idx], ...updates };
      localStorage.setItem("spellwise_categories", JSON.stringify(cats));
    } catch {}
    return;
  }
  try {
    await fetch(`${DB}/spellwise/categories/${id}.json`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updates),
    });
  } catch {}
}

export async function deleteCategory(id) {
  // Guard: disallow deletion if any reward references this category
  const data = await fbGet("data");
  const rewards = data?.rewards || [];
  if (rewards.some(r => r.categoryId === id)) {
    throw new Error("Cannot delete category: rewards are using it.");
  }
  if (DEMO_MODE) {
    try {
      const raw = localStorage.getItem("spellwise_categories");
      const cats = raw ? JSON.parse(raw) : [...DEFAULT_CATEGORIES];
      localStorage.setItem("spellwise_categories", JSON.stringify(cats.filter(c => c.id !== id)));
    } catch {}
    return;
  }
  try {
    await fetch(`${DB}/spellwise/categories/${id}.json`, { method: "DELETE" });
  } catch {}
}

// Step 5: resolve the avatar image slug for a user, defaulting by name if avatarImage not set
export function getAvatarImage(user) {
  if (user?.avatarImage) return user.avatarImage;
  if (user?.name === "Maisha") return "maisha-1";
  if (user?.name === "Aariv") return "aariv-4";
  return "maisha-1";
}
